"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportNullifierProof = void 0;
const circuits_1 = require("@unirep/circuits");
const types_1 = require("./types");
const utils_1 = require("./utils");
/**
 *  Verify the voter identity for claiming reputation
 */
class ReportNullifierProof extends circuits_1.BaseProof {
    constructor(_publicSignals, _proof, prover) {
        super(_publicSignals, _proof, prover);
        this.output = {
            control: 0,
            currentEpochKey: 1,
        };
        this.input = {
            reportNullifier: 2,
            reportId: 3,
        };
        this.reportNullifier = BigInt(_publicSignals[this.input.reportNullifier]);
        this.reportId = BigInt(_publicSignals[this.input.reportId]);
        this.currentEpochKey = BigInt(_publicSignals[this.output.currentEpochKey]);
        this.control = BigInt(this.publicSignals[this.output.control]);
        const { nonce, epoch, attesterId, revealNonce, chainId } = (0, utils_1.decodeEpochKeyControl)(this.control);
        this.nonce = nonce;
        this.epoch = epoch;
        this.attesterId = attesterId;
        this.revealNonce = revealNonce;
        this.chainId = chainId;
        this.circuit =
            types_1.UnirepSocialCircuit.reportNullifierProof;
    }
}
exports.ReportNullifierProof = ReportNullifierProof;
